import { createEntityAdapter, EntityState } from '@reduxjs/toolkit';
import { on, reducer } from 'ts-action';
import { Cluster } from '../clustering.types';
import * as morphologyActions from '../actions/morphology.actions';
import * as clusterActions from '../actions/cluster.actions';
import { sortComparer } from './cluster.reducer';

export type MorphologyState = EntityState<Cluster>;

declare module 'react-redux' {
  interface DefaultRootState {
    morphology: MorphologyState;
  }
}

const morphologyAdapter = createEntityAdapter<Cluster>({
  sortComparer,
});
export const { selectAll, selectEntities, selectById } =
  morphologyAdapter.getSelectors();

export default reducer<MorphologyState>(
  morphologyAdapter.getInitialState(),
  on(clusterActions.cleanUp, () => morphologyAdapter.getInitialState()),
  on(morphologyActions.load, (state, { morphologies }) =>
    morphologyAdapter.setAll(state, morphologies),
  ),
  on(
    morphologyActions.replaceMorphology,
    (state, { newMorphology, oldMorphology }) => {
      let newState = state;
      if (oldMorphology != null) {
        newState = morphologyAdapter.removeOne(newState, oldMorphology.id);
      }
      return morphologyAdapter.addOne(newState, newMorphology);
    },
  ),
  on(morphologyActions.removeMorphology, (state, { morphology }) => {
    let newState = state;
    const morphologies = morphologyAdapter.getSelectors().selectAll(state);
    // Re-prioritize morphologies
    const prioritizedMorphologies = morphologies.map((currMorphology) => {
      if (currMorphology.priority > morphology.priority) {
        return {
          ...currMorphology,
          priority: currMorphology.priority - 1,
        };
      }
      return currMorphology;
    });
    newState = morphologyAdapter.setAll(newState, prioritizedMorphologies);
    return morphologyAdapter.removeOne(newState, morphology.id);
  }),
);
